import { render, staticRenderFns } from "./EditVisibility.vue?vue&type=template&id=c80feaf4&scoped=true"
import script from "./EditVisibility.vue?vue&type=script&lang=js"
export * from "./EditVisibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80feaf4",
  null
  
)

export default component.exports